import { validateCSSSize } from '../../../utils/validate-css-size.js';

export function coerceWidthValue(
  widthValue: string | number | undefined,
  horizontalPadding: number,
): string | undefined {
  let layoutWidth;
  if (widthValue === undefined) {
    return undefined;
  } else if (typeof widthValue === 'number') {
    layoutWidth = `${widthValue - horizontalPadding}px`;
  } else {
    const cssSizeValidated = validateCSSSize(widthValue);
    layoutWidth = cssSizeValidated
      ? `calc(${widthValue} - ${horizontalPadding}px)`
      : undefined;
  }
  return layoutWidth;
}
